import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchProfile, readWallet } from "../../helpers/profileApi";

/**
 * Кошелёк — балансы участника в валютах платформы.
 *
 * Вынесен из профиля по решению Максима 22.08.2026. В FairyTON эти цифры
 * стоят внутри профиля, но там это мобильное приложение с одной длинной
 * страницей. В кабинете профиль — это анкета, и соседство «отчество» и
 * «баланс в токенах» читается странно: одно заполняешь, другое смотришь.
 *
 * Данных за цифрами пока нет: ручки балансов на платформе не существует.
 * Показываем прочерки — выдуманные числа в разделе про деньги опаснее,
 * чем честный пропуск.
 */

const PUBLIC = process.env.PUBLIC_URL || "";

const CURRENCIES = [
  {
    key: "point",
    title: "FD Point",
    note: "Баллы за активность: квесты, задания, участие в событиях.",
  },
  {
    key: "token",
    title: "FD Token",
    note: "Токен платформы.",
  },
  {
    key: "usdt",
    title: "FD Usdt",
    note: "Расчётная валюта для выплат.",
  },
  {
    key: "rub",
    title: "FD Rub",
    note: "Рублёвый баланс: покупки и оплата подписки внутри платформы.",
  },
];

const WalletPage = () => {
  const [balances, setBalances] = useState(null);

  useEffect(() => {
    let alive = true;
    // Балансы отдаёт та же ручка профиля, что и достижения.
    fetchProfile()
      .then((data) => {
        if (alive) setBalances(readWallet(data));
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);

  return (
  <div className="fw-page">
    <Link className="fw-back" to={`${PUBLIC}/profile`}>
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M15 18l-6-6 6-6" />
      </svg>
      В профиль
    </Link>

    <h1 className="fw-title">Кошелёк</h1>
    <p className="fw-sub">
      Ваши балансы в валютах платформы. Пополняются за активность в мирах
      и за участие в проектах.
    </p>

    <div className="fw-wallet">
      {CURRENCIES.map((c) => (
        <section className="fw-card fw-wallet-item" key={c.key}>
          <b>
            {balances && balances[c.key] !== null && balances[c.key] !== undefined
              ? balances[c.key].toLocaleString("ru-RU")
              : "—"}
          </b>
          <span className="fw-wallet-title">{c.title}</span>
          <span className="fw-wallet-note">{c.note}</span>
        </section>
      ))}
    </div>

    <section className="fw-card fw-box">
      <h3>Пока только балансы</h3>
      <p className="fw-note mb-0">
        История начислений, обмен и вывод появятся здесь позже. Что именно
        нужно в первую очередь — решаем с Максимом.
      </p>
    </section>
  </div>
  );
};

export default WalletPage;
